import React from 'react'

import AppDirectoryPromo from '../../../../assets/images/promo-oauth2-app-directory.png'

import './OAuth2AppDirectoryUpsell.scss'

export const OAuth2AppDirectoryUpsellBody: React.FC = () => {
  return (
    <>
      <img src={AppDirectoryPromo} alt='App directory promo' className='zocks-border-0.5 app-directory-upsell-promo object-fit-contain' />
      <div className='d-flex flex-column gap-1'>
        <h5>
          Bring your <span className='zocks-text-primary'>client intelligence</span> into tools you and your team use
        </h5>
        <div className='paragraph-medium'>Ask questions, get answers grounded in real client data without leaving the tools you already work in.</div>
      </div>
    </>
  )
}

export const OAuth2AppDirectoryUpsellFeatures: React.FC = () => {
  return (
    <>
      <div className='d-flex gap-2'>
        <i className='bi bi-check-lg zocks-text-primary' />
        <div className='paragraph-medium'>
          <strong>Natural-language queries</strong>: Ask anything about your clients and meetings and get answers grounded in real data.
        </div>
      </div>
      <div className='d-flex gap-2'>
        <i className='bi bi-check-lg zocks-text-primary' />
        <div className='paragraph-medium'>
          <strong>Build anything</strong>: Create reports, presentations, and client-facing outputs directly in the tools you use.
        </div>
      </div>
      <div className='d-flex gap-2 mb-3'>
        <i className='bi bi-check-lg zocks-text-primary' />
        <div className='paragraph-medium'>
          <strong>Access to all apps</strong>: Access every app on the Professional plan, now and as we add more.
        </div>
      </div>
    </>
  )
}
